<div class="toaster-container">
    @if (notifications$ | async; as notificationList) {
        <div>
            @for (notification of notificationList; track notification) {
                <checkout-toaster [notification]="notification"></checkout-toaster>
            }
        </div>
    }
</div>
